import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const HeaderPublic = () => {
    const location = useLocation();

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const [isBlogOpen, setIsBlogOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleServices = (e) => {
        e.preventDefault();
        setIsServicesOpen(!isServicesOpen);
    };

    const toggleBlog = (e) => {
        e.preventDefault();
        setIsBlogOpen(!isBlogOpen);
    };

    const closeAll = () => {
        setIsMenuOpen(false);
        setIsServicesOpen(false);
        setIsBlogOpen(false);
    };

    const isActive = (path) => {
        if (Array.isArray(path)) {
            return path.some(p => location.pathname === p);
        }
        return location.pathname === path;
    };

    const isServicesActive = isActive([
        '/psicologia-infantil',
        '/pediatra',
        '/fisioterapia',
        '/avaliacao-neuropsicologica',
        '/psicopedagogia',
        '/nutricionista'
    ]);

    const isBlogActive = isActive([
        '/transtornos-ansiedade-infantil',
        '/transtorno-deficit-atencao-hiperatividade-tdah'
    ]);

    return (
        <header>
            <div className="container HeaderContent">
                <div className="logo">
                    <Link to="/home" title="Kids Life">
                        <img
                            src="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Ficones%2Flogo-crescer.webp?alt=media&token=9cb0e4a9-e6e7-468a-8113-bc529e042c93"
                            alt="Log CreSer"
                            title="Logo CreSer"
                        />
                    </Link>
                </div>
                <div className="contact-details">
                    <p className="mail">
                        <a href="mailto:clinicacrescerferraz@hotmail.com">
                            <span className="__cf_email__">clinicacrescerferraz@hotmail.com</span>
                        </a>
                        <span className="fa fa-envelope"></span>
                    </p>
                    <p className="phone-no">
                        <i>(11) 91913-9787</i>
                        <span className="fa fa-phone"></span>
                    </p>
                </div>
            </div>

            <div id="menu-container">
                <div className="container">
                    <nav id="main-menu">
                        <div className="dt-menu-toggle" id="dt-menu-toggle" onClick={toggleMenu}>
                            Menu<span className="dt-menu-toggle-icon"></span>
                        </div>
                        <ul id="menu-main-menu" className={`menu ${isMenuOpen ? 'open' : ''}`} style={{ display: isMenuOpen ? 'block' : '' }}>
                            <li className={`${isActive('/home') ? 'current_page_item' : ''} menu-item-simple-parent menu-item-depth-0 red`}>
                                <Link to="/home" onClick={closeAll}> Home </Link>
                            </li>
                            <li className={`${isActive('/sobre') ? 'current_page_item' : ''} mustard`}>
                                <Link to="/sobre" onClick={closeAll}> Sobre </Link>
                            </li>
                            <li className={`${isActive('/equipe') ? 'current_page_item' : ''} green`}>
                                <Link to="/equipe" onClick={closeAll}> Equipe </Link>
                            </li>
                            <li className={`menu-item-simple-parent menu-item-depth-0 ${isServicesActive ? 'current_page_item' : ''} ${isServicesOpen ? 'dt-is-expanded' : ''}`}>
                                <a href="/#" title="" onClick={toggleServices}>Serviços</a>
                                <ul className={`sub-menu ${isServicesOpen ? 'dt-is-expanded-submenu' : ''}`}>
                                    <li className={isActive('/psicologia-infantil') ? 'current_page_item' : ''}><Link to="/psicologia-infantil" onClick={closeAll}>Psicologia infantil</Link></li>
                                    <li className={isActive('/pediatra') ? 'current_page_item' : ''}><Link to="/pediatra" onClick={closeAll}>Pediatria</Link></li>
                                    <li className={isActive('/fisioterapia') ? 'current_page_item' : ''}><Link to="/fisioterapia" onClick={closeAll}>Fisioterapia</Link></li>
                                    <li className={isActive('/avaliacao-neuropsicologica') ? 'current_page_item' : ''}><Link to="/avaliacao-neuropsicologica" onClick={closeAll}>Avaliação Neuropsicológica</Link></li>
                                    <li className={isActive('/psicopedagogia') ? 'current_page_item' : ''}><Link to="/psicopedagogia" onClick={closeAll}>Psicopedagogia</Link></li>
                                    <li className={isActive('/nutricionista') ? 'current_page_item' : ''}><Link to="/nutricionista" onClick={closeAll}>Nutricionista</Link></li>
                                </ul>
                                <a className="dt-menu-expand" onClick={toggleServices}>{isServicesOpen ? '-' : '+'}</a>
                            </li>
                            <li className={`menu-item-simple-parent menu-item-depth-0 ${isBlogActive ? 'current_page_item' : ''} ${isBlogOpen ? 'dt-is-expanded' : ''}`}>
                                <a href="/#" title="" onClick={toggleBlog}>Blog</a>
                                <ul className={`sub-menu ${isBlogOpen ? 'dt-is-expanded-submenu' : ''}`}>
                                    <li className={isActive('/transtornos-ansiedade-infantil') ? 'current_page_item' : ''}><Link to="/transtornos-ansiedade-infantil" onClick={closeAll}>Transtorno de ansiedade infantil</Link></li>
                                    <li className={isActive('/transtorno-deficit-atencao-hiperatividade-tdah') ? 'current_page_item' : ''}><Link to="/transtorno-deficit-atencao-hiperatividade-tdah" onClick={closeAll}>Transtorno de déficit de atenção e hiperatividade (TDAH)</Link></li>
                                </ul>
                                <a className="dt-menu-expand" onClick={toggleBlog}>{isBlogOpen ? '-' : '+'}</a>
                            </li>
                            <li className={`${isActive('/contato') ? 'current_page_item' : ''} menu-item-simple-parent menu-item-depth-0`}>
                                <Link to="/contato" title="" onClick={closeAll}>Fale Conosco</Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </header>
    );
};

export default HeaderPublic;
